export enum TrendingTypes {
  Above,
  Under,
}
